import { useEffect, useRef } from 'react';

/**
 * Custom hook to track if a component is mounted
 * Useful for preventing state updates on unmounted components
 * @returns {React.MutableRefObject<boolean>} isMounted ref
 */
export const useIsMounted = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};
